// ===========================================
// Data Export Section Component
// ===========================================

import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { CARD_COLORS } from './account.constants';

interface Props {
  isFunMode: boolean;
  isExporting: boolean;
  onExport: () => void;
}

export default function DataExportSection({ isFunMode, isExporting, onExport }: Props) {
  return (
    <Card
      sx={{
        mb: 3,
        ...(isFunMode && {
          borderRadius: 4,
          border: `3px solid ${CARD_COLORS.export.border}`,
          bgcolor: CARD_COLORS.export.bg,
          boxShadow: '4px 4px 0px rgba(0,0,0,0.08)',
        }),
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <Box
            sx={{
              bgcolor: isFunMode ? `${CARD_COLORS.export.border}30` : 'info.light',
              borderRadius: '50%',
              width: 48,
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: isFunMode ? CARD_COLORS.export.border : 'info.main',
              flexShrink: 0,
            }}
          >
            <DownloadIcon />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6">Export Your Data</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Download a copy of all your personal data. This includes your profile
              information, students, attendance records, invoices, and other associated data.
            </Typography>
            <Button
              variant="outlined"
              startIcon={isExporting ? <CircularProgress size={16} /> : <DownloadIcon />}
              onClick={onExport}
              disabled={isExporting}
            >
              {isExporting ? 'Exporting...' : 'Download My Data'}
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
